import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ProplayerService } from '../../shared/services/proplayer.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ChessboardFun,
  chessBoard,
  clearCanvas,
  drawArrow,
  initializeCanvas,
  rotateChess,
} from '../../shared/functions/chessboardMain';
import {
  highlightLastMove,
  playergameId,
  resetChess,
  undoMove,
  updateBoard,
} from '../../shared/functions/onDrop';
import { game } from '../../shared/functions/chess';
import { CommonModule } from '@angular/common';
import { LoginPopupComponent } from '../../shared/login-popup/login-popup.component';
import { Chess } from '../../shared/js';
import { PieceIconPipe } from '../../shared/pipes/piece-icon.pipe';
import { DecryptionService } from '../../shared/services/decryption.service';
import { PreviousRouteService } from '../../shared/services/previous-route.service';

@Component({
  selector: 'app-history-chess-board',
  standalone: true,
  templateUrl: './history-chess-board.component.html',
  styleUrl: './history-chess-board.component.scss',
  imports: [CommonModule, LoginPopupComponent, PieceIconPipe],
})
export class HistoryChessBoardComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  @ViewChild('moveScrollContainer') private moveScrollContainerVertical: any;
  @ViewChild('moveScrollContainer2') private moveScrollContainerHorizontal: any;
  moveScrollContainers!: QueryList<ElementRef>;
  moves!: any[];
  chessBoardMove!: any[];
  currentIndex!: number;
  playerGames: any;
  chessboardDetails: any;
  playerallMove!: string[];
  blackwinner!: boolean;
  whiteWinner!: boolean;
  drawgame!: boolean;
  isFlipped!: boolean;
  modalDisplayStyle!: boolean;
  lastIndexGame: any;
  chessboard: any;
  constructor(
    private playerData: ProplayerService,
    private activatedRoute: ActivatedRoute,
    private navigationService: PreviousRouteService,
    private elRef: ElementRef,
    private router: Router,
    private decryptionApi: DecryptionService
  ) {}

  ngOnInit(): void {
    this.currentIndex = 0;
    this.playerGames = this.activatedRoute.snapshot.paramMap.get('id');
    playergameId(this.playerGames);
  }
  ngAfterViewInit(): void {
    this.scrollToCurrentMove(this.moveScrollContainerVertical);
    this.scrollToCurrentMove(this.moveScrollContainerHorizontal);
    ChessboardFun();
    resetChess();
    this.playerData.playeredGames(this.playerGames).subscribe({
      next: (res) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        switch (jsondecrpt.Result) {
          case '1-0':
            this.whiteWinner = true;
            break;
          case '0-1':
            this.blackwinner = true;
            break;
          case '1/2-1/2':
            this.drawgame = true;
            break;
          default:
            break;
        }

        this.chessboardDetails = jsondecrpt;

        this.moves = this.parsePGN(jsondecrpt?.Moves);
        this.lastIndexGame = this.moves?.length;
        this.playerallMove = jsondecrpt.Moves;
      },
    });
    initializeCanvas(this.elRef);
  }

  ngAfterViewChecked() {
    this.scrollToCurrentMove(this.moveScrollContainerVertical);
    this.scrollToCurrentMove(this.moveScrollContainerHorizontal);
  }

  // private scrollToCurrentMove() {
  //   this.moveScrollContainers.forEach((container) => {
  //     if (container) {
  //       const moveElements = container.nativeElement.children;
  //       if (moveElements[this.currentIndex]) {
  //         moveElements[this.currentIndex].scrollIntoView({
  //           behavior: 'smooth',
  //           block: 'center',
  //         });
  //       }
  //     }
  //   });
  // }

  nextMove(): void {
    if (this.currentIndex < this.moves.length) {
      const move = this.moves[this.currentIndex];
      if (move === '1/2-1/2' || move === '1-0' || move === '0-1') {
        return;
      }
      clearCanvas();
      game.move(move);
      chessBoard.position(game.fen());
      const moves: any = game.history({ verbose: true });
      const lastMove = moves.length ? moves[moves.length - 1] : null;
      highlightLastMove(lastMove?.from, lastMove?.to);
      drawArrow(lastMove?.from, lastMove?.to);
      updateBoard();
      this.currentIndex++;
    }
  }

  parsePGN(pgn: string): string[] {
    const movesArray: string[] = [];
    const moves = pgn.split(/\d+\./).slice(1);

    for (let move of moves) {
      const moveSequence = move.trim().split(/\s+/);
      for (let singleMove of moveSequence) {
        if (singleMove.trim() !== '') {
          movesArray.push(singleMove);
        }
      }
    }

    // Check and remove the last element if it's a result
    const lastMove = movesArray[movesArray.length - 1];
    if (['1-0', '0-1', '1/2-1/2'].includes(lastMove)) {
      movesArray.pop();
    }

    return movesArray;
  }

  prevMove() {
    if (this.currentIndex > 0) {
      clearCanvas();
      this.currentIndex--;
      undoMove();
      updateBoard();
      const moves: any = game.history({ verbose: true });
      const lastMove = moves.length ? moves[moves.length - 1] : null;
      if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
    }
  }

  endChessBoard() {
    this.currentIndex = this.lastIndexGame;
    game.loadPgn(this.chessboardDetails.Moves);
    chessBoard.position(game.fen());
    updateBoard();
  }

  filpChessBoard() {
    this.isFlipped = !this.isFlipped;
    rotateChess();
    const moves: any = game.history({ verbose: true });
    const lastMove = moves.length ? moves[moves.length - 1] : null;
    if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
  }

  resetChessBoard() {
    this.currentIndex = 0;
    resetChess();
    updateBoard();
  }

  GetChildData(data: any) {
    this.modalDisplayStyle = data;
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    event.stopPropagation();
    if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'F' ||
      event.key === 'f' ||
      event.key === 'R' ||
      event.key === 'r'
    ) {
      event.preventDefault();
      if (event.key === 'ArrowLeft') {
        this.prevMove();
      } else if (event.key === 'ArrowRight') {
        this.nextMove();
      } else if (event.key === 'ArrowUp') {
        this.endChessBoard();
        clearCanvas();
      } else if (event.key === 'ArrowDown') {
        this.resetChessBoard();
        highlightLastMove();
        clearCanvas();
      } else if (event.key === 'F' || event.key === 'f') {
        this.filpChessBoard();
      } else if (event.key === 'R' || event.key === 'r') {
        this.resetChessBoard();
      }
    }
  }

  getMove(data: any) {
    clearCanvas();
    this.currentIndex = data;
    const movesUpToCurrentIndex = this.moves.slice(0, this.currentIndex + 1);
    const chess = new Chess();
    for (const move of movesUpToCurrentIndex) {
      chess.move(move);
    }
    const moves: any = chess.history({ verbose: true });
    const lastMove = moves.length ? moves[moves.length - 1] : null;
    if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
    highlightLastMove(lastMove?.from, lastMove?.to);
    game.loadPgn(chess.pgn());
    chessBoard.position(game.fen());
    updateBoard();
    this.currentIndex++;
  }

  scrollToCurrentMove(containerRef: ElementRef) {
    if (containerRef) {
      const container = containerRef.nativeElement;
      const selectedMove = container.querySelector('.selected-move');
      if (selectedMove) {
        const containerHeight = container.clientHeight;
        const containerWidth = container.clientWidth;
        const moveHeight = selectedMove.clientHeight;
        const moveWidth = selectedMove.clientWidth;
        const offsetTop = selectedMove.offsetTop - container.offsetTop;
        const offsetLeft = selectedMove.offsetLeft - container.offsetLeft;

        container.scrollTop = offsetTop - containerHeight / 2 + moveHeight / 2;
        container.scrollLeft = offsetLeft - containerWidth / 2 + moveWidth / 2;
      }
    }
  }

  mainMenu() {
    const previousUrl: any = this.navigationService.getPreviousUrl();

    if (previousUrl !== this.router.url) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['database']);
    }
  }
}
